module.exports = __webpack_public_path__ + "fonts/6610bc1.ttf";